import Vue from 'vue';
import Vuex from 'vuex';
import report from './modules/report';
import auth from './modules/auth';
import checkout from './modules/checkout';
import discount from './modules/discount';
import outlet from './modules/outlet';
import shifts from './modules/shifts';
import tag from './modules/tag';
import tax from './modules/tax';
import payment from './modules/payment';
import product from './modules/product';
import modifierSet from './modules/modifierSet';
import reportProduct from './modules/report-product';
import category from './modules/category';
import metadata from './modules/metadata';
import region from './modules/region';
import tradingArea from './modules/trading-area';
import zone from './modules/zone';
import centralSettings from './modules/central-settings';
import hubSettings from './modules/hub-settings';
import variant from './modules/variant';
import central from './modules/central';
import till from './modules/till';
import planogram from './modules/planogram';
import faqGuideline from './modules/faq-guideline';
import localAccount from './modules/local-account';
import royalty from './modules/royalty';
import loyaltyCategory from './modules/loyalty-category';
import salesCategory from './modules/sales-category';
import salesMovement from './modules/sales-movement';
import receiptPromotion from './modules/receipt-promotion';
import tillFilter from './modules/till-filter';
import tillSummary from './modules/till-summary';
import stockMovement from './modules/inventory-stock-movement';
import inventoryStockReceive from './modules/inventory-stock-receive';
import stockReturn from './modules/inventory-stock-return';
import inventoryStockCheck from './modules/inventory-stock-check';
import voidedSales from './modules/voided-sales';
import subsidy from './modules/subsidy';
import clawback from './modules/clawback';
import profit from './modules/profit';
import costGoodSold from './modules/cost-good-sold';
import marketplaceApp from './modules/marketplace-app';
import budiSummary from './modules/budi-summary';
import fuelPriceReport from './modules/fuel-price-report';
import { createVuexLoader } from 'vuex-loading';

const VuexLoading = createVuexLoader({
    moduleName: 'loading',
    componentName: 'v-loading',
    className: 'v-loading',
});

Vue.use(Vuex);
Vue.use(VuexLoading);

export default new Vuex.Store({
    plugins: [VuexLoading.Store],
    modules: {
        report,
        auth,
        checkout,
        discount,
        outlet,
        shifts,
        modifierSet,
        tag,
        payment,
        product,
        tax,
        reportProduct,
        category,
        metadata,
        centralSettings,
        variant,
        central,
        region,
        till,
        planogram,
        faqGuideline,
        localAccount,
        tradingArea,
        zone,
        royalty,
        loyaltyCategory,
        salesCategory,
        salesMovement,
        receiptPromotion,
        tillFilter,
        tillSummary,
        stockMovement,
        inventoryStockReceive,
        stockReturn,
        inventoryStockCheck,
        voidedSales,
        profit,
        costGoodSold,
        hubSettings,
        subsidy,
        clawback,
        marketplaceApp,
        budiSummary,
        fuelPriceReport,
    },
});



// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js